import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Spinner: React.FC = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">A carregar…</span>
    </div>
  </div>
);

/** Exige sessão autenticada; senão redirecciona para /login. */
export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
};

/** Exige utilizador staff; senão mostra aviso. */
export const RequireStaff: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!user.is_staff) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          Acesso restrito a administradores.
        </div>
      </div>
    );
  }
  return <>{children}</>;
};

export default RequireAuth;
